import type { ComponentProps } from 'react'
import React, { memo } from 'react'

import classes from './SVG.module.scss'

export type Props = {
  label?: string
  /**
   * Accessible name, following <img> alt semantics: a non-empty string exposes the icon
   * as role="img" with that label; "" marks it decorative (hidden from assistive tech);
   * omitted leaves accessibility to the caller.
   */
  alt?: string
  /** raw svg content */
  content: string
} & ComponentProps<'span'>

/**
 * Component for inserting inline svgs,
 * should be used in conjunction with `require("svgpath.svg?raw")`
 */
export const SVG = memo<Props>(function SVG({ label, alt, content, className, ...props }) {
  const a11y: ComponentProps<'span'> = alt === undefined ? {} : alt === '' ? { 'aria-hidden': true } : { role: 'img', 'aria-label': alt }
  return <span {...props} {...a11y} className={cn(classes.icon, className)} dangerouslySetInnerHTML={{ __html: content }} data-label={label} />
})
